<template>
  <b-modal
    :id="modalId"
    centered
    size="md"
    title="Selecionar inscrição estadual"
    hide-footer
    body-class="p-0"
    @hidden="resetSelecao"
  >
    <div class="p-5">
      <p class="text-justify text-muted mb-4">
        Este cliente possui mais de uma inscrição estadual. Selecione qual
        inscrição deseja utilizar nesta operação.
      </p>
      <b-form-group label="Inscrições disponíveis" label-for="selecao_ie">
        <b-form-radio-group
          id="selecao_ie"
          v-model="inscricaoSelecionada"
          stacked
        >
          <div
            v-for="(inscricao, index) in opcoesInscricoes"
            :key="'opcao_ie_' + index"
            class="mb-3 p-3 border rounded"
            :class="{
              'border-primary': inscricaoSelecionada === inscricao.value,
            }"
          >
            <b-form-radio :value="inscricao.value">
              <strong>{{ inscricao.numero_ie }}</strong>
              <b-badge
                v-if="inscricao.principal"
                variant="primary"
                class="ml-2"
              >
                Principal
              </b-badge>
            </b-form-radio>
            <div v-if="inscricao.endereco" class="mt-2 ml-4 text-muted small">
              {{ inscricao.endereco.logradouro ?? "" }},
              {{ inscricao.endereco.numero ?? "" }} -
              {{ inscricao.endereco.bairro ?? "" }}
              <br />
              {{ inscricao.endereco?.cidade?.cidade ?? "" }}
              <span
                v-if="inscricao.endereco?.cidade?.uf || inscricao.endereco.uf"
              >
                - {{ inscricao.endereco?.cidade?.uf ?? inscricao.endereco.uf }}
              </span>
            </div>
          </div>
        </b-form-radio-group>
      </b-form-group>
      <div class="d-flex justify-content-end mt-4">
        <b-button
          variant="clean"
          class="font-weight-bold mr-2"
          @click="$bvModal.hide(modalId)"
        >
          Cancelar
        </b-button>
        <b-button
          variant="primary"
          class="font-weight-bold"
          :disabled="!inscricaoSelecionada"
          @click="confirmarSelecao"
        >
          Confirmar
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "app-selecionar-inscricao-estadual-modal",
  props: {
    modalId: {
      type: String,
      required: true,
    },
    iePrincipal: {
      type: String,
      default: "",
    },
    enderecoPrincipal: {
      type: Object,
      default: null,
    },
    inscricoesAdicionais: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      inscricaoSelecionada: null,
    };
  },
  computed: {
    opcoesInscricoes() {
      const opcoes = [];

      if (this.iePrincipal && String(this.iePrincipal).trim() !== "") {
        opcoes.push({
          value: {
            numero_ie: this.iePrincipal,
            principal: true,
            endereco: this.enderecoPrincipal,
          },
          numero_ie: this.iePrincipal,
          principal: true,
          endereco: this.enderecoPrincipal,
        });
      }

      (this.inscricoesAdicionais || []).forEach((inscricao) => {
        const numeroIE =
          typeof inscricao === "string" ? inscricao : inscricao.numero_ie;
        const principal =
          typeof inscricao === "object" ? !!inscricao.principal : false;
        const endereco =
          typeof inscricao === "object" ? inscricao.endereco : null;

        if (!numeroIE) return;

        const jaExiste = opcoes.some((opcao) => opcao.numero_ie === numeroIE);

        if (!jaExiste) {
          opcoes.push({
            value: {
              numero_ie: numeroIE,
              principal: principal && opcoes.length === 0,
              endereco: endereco,
            },
            numero_ie: numeroIE,
            principal: principal && opcoes.length === 0,
            endereco: endereco,
          });
        }
      });

      return opcoes;
    },
  },
  methods: {
    resetSelecao() {
      this.inscricaoSelecionada = null;
    },
    confirmarSelecao() {
      if (!this.inscricaoSelecionada) {
        this.$toast.warning("Selecione uma inscrição estadual!");
        return;
      }

      this.$emit("selected", this.inscricaoSelecionada);
      this.$bvModal.hide(this.modalId);
    },
    abrir() {
      this.resetSelecao();
      this.$bvModal.show(this.modalId);
    },
  },
};
</script>
